import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ProfileHeader from "../../../components/profile-header";

// Import images
import profilebg7 from "../../../assets/images/page-img/profile-bg7.png";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import axios from "axios";
import Error500 from "../errors/error500";
import { Oval } from "react-loader-spinner";

const StoreDetail = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [pageLoading, setPageLoading] = useState(false);
  const [data, setData] = useState([]);
  const [apierror, setApiError] = useState(false);
  const users = JSON.parse(localStorage.getItem("users"));
  useEffect(() => {
    getEnrolledCourses();
  }, []);

  const getEnrolledCourses = async () => {
    const userId = localStorage.getItem("userId");
    try {
      setPageLoading(true);
      const response = await axios.post(webServiceUrl.enrolledCourses, {
        users,
      });

      console.log(response, "error");

      console.log(response.data.enrolledCourses, "resposne data");
      setData(response.data.enrolledCourses);
    } catch (error) {
      console.log(error, "ERROR coming From  getEnrolledCourses ");
      setData([]); // Set empty array if error
      setApiError(true);
    } finally {
      setIsLoading(false); // Only stop loading after fetch attempt
      setTimeout(() => setPageLoading(false), 1500);
    }
  };

  // useEffect(()=>{
  //   console.log(data, "data insert");

  // }, [])

  if (pageLoading) {
    return (
      <>
        {/* <div className="d-flex py-6 d-flex justify-content-center" style={{ minHeight: "90vh", padding: "4rem" }}>
        <Loading />
      </div> */}
        <div
          className="d-flex justify-content-center "
          style={{ height: "85vh", paddingTop: "15vh" }}
        >
          <Oval
            height="50"
            width="50"
            color="#4fa94d"
            secondaryColor="#4fa94d"
          />
        </div>
      </>
    );
  }

  // console.log(course, " course from coruse card");

  return (
    <>
      <ProfileHeader img={profilebg7} />
      <div id="content-page" className="content-inner store-details pt-4">
        <Container>
          <Row>
            <div
              className="header-title"
              style={{ textAlign: "left", width: "100%" }}
            >
              <h1 style={{ textAlign: "center", width: "100%" }}>
                Enrolled Courses
              </h1>
            </div>
            <Col lg="12">
              <Row>
                {isLoading ? (
                  <div className="d-flex justify-content-center align-items-center mainHeaderImg">
                    <Oval
                      visible={true}
                      height="50"
                      width="50"
                      color="#4fa94d"
                      secondaryColor="#4fa94d"
                      radius="12.5"
                      ariaLabel="mutating-dots-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                  </div>
                ) : apierror == true ? (
                  <Error500 />
                ) : data.length === 0 ? (
                  <p className="text-center fs-5 text-muted mt-3">
                    No Course available.
                  </p>
                ) : (
                  data.map((course, index) => (
                    <Col
                      sm="6"
                      md="6"
                      lg="4"
                      // key={course?.data.}
                      className="mt-4"
                    >
                      <div className="mx-3">
                        <CourseCard course={course} />
                      </div>
                    </Col>
                  ))
                )}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

// Course card component
const CourseCard = ({ course }) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2300);
    return () => clearTimeout(timer);
  });

  localStorage.setItem("course", JSON.stringify(course));

  console.log(course?.logo_image, "course?.logo_image");

  return (
    <Link
      to={
        course?.student?.lessonPlanCount !== 0
          ? `/dashboard/blog/blog-detail/${course?.school_code}`
          : undefined
      }
      state={{ course }}
      className="text-decoration-none"
    >
      <div
        className="card-block card-stretch card-height product border rounded p-3"
        style={{
          boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
          backgroundColor: "white",
        }}
      >
        <div className="image-block position-relative productCardImg overflow-hidden">
          {loading && <Skeleton height={200} className="rounded-3" />}

          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <img
              src={course?.logo_image}
              className="rounded"
              alt="product-img"
              style={{
                display: loading ? "none" : "block",
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain", // ⭐ important
              }}
              onLoad={() => setLoading(false)}
            />
          </div>
        </div>
        {/* <h6 className="price cursor-pointer secondaryBG ">Enroll Now</h6> */}

        <div className="product-description my-4">
          {/* <h4 className="fw-bold">{course?.school_name}</h4> */}
          <h4 className="fw-bold">
            {" "}
            {course?.school_name
              .toLowerCase()
              .replace(/\b\w/g, (char) => char.toUpperCase())}
          </h4>
        </div>

        <div>
          {course?.student?.lessonPlanCount !== 0 && (
            <ul className="list-inline m-0 p-0 d-flex align-items-center justify-content-center gap-4">
              <li>
                <button
                  type="button"
                  className="btn btn-primary px-4 button-card"
                >
                  View Details
                </button>
              </li>
            </ul>
          )}
        </div>
      </div>
    </Link>
  );
};

export default StoreDetail;

// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { Container, Row, Col } from "react-bootstrap";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import ProfileHeader from "../../../components/profile-header";

// // Import images
// import store1 from "../../../assets/images/page-img/robotics.png";
// import store6 from "../../../assets/images/page-img/ai.png";
// import store2 from "../../../assets/images/page-img/py.png";
// import store3 from "../../../assets/images/page-img/node.png";
// import store4 from "../../../assets/images/page-img/java.png";
// import store5 from "../../../assets/images/page-img/ml.png";
// import profilebg7 from "../../../assets/images/page-img/profile-bg7.png";
// import AXIOSCONFIGMETHOD from "../../../components/apiCall/axiosConfig";
// import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
// import axios from "axios";

// const courses = [
//   {
//     id: 1,
//     title: "Robotics Program",
//     img: store1,
//     description:
//       "Build and program robots using modern tools and hands-on projects.",
//     link: "/dashboard/blog/blog-detail",
//   },
//   {
//     id: 2,
//     title: "Python AI Program",
//     img: store2,
//     description:
//       "Learn Python for AI, covering ML, deep learning, and automation.",
//     link: "/dashboard/blog/blog-detail",
//   },
//   {
//     id: 3,
//     title: "AI Program",
//     img: store6,
//     description:
//       "Master AI concepts like neural networks, NLP, and problem-solving.",
//     link: "/dashboard/blog/blog-detail",
//   },
//   {
//     id: 4,
//     title: "MERN Stack Program",
//     img: store3,
//     description:
//       "Learn MongoDB, Express, React, and Node.js to build web apps.",
//     link: "/dashboard/blog/blog-detail",
//   },
//   {
//     id: 5,
//     title: "Java Development Program",
//     img: store4,
//     description:
//       "Master Java, OOP, Spring Boot, and enterprise app development.",
//     link: "/dashboard/blog/blog-detail",
//   },
//   {
//     id: 6,
//     title: "Machine Learning Program",
//     img: store5,
//     description:
//       "Explore ML algorithms, data science, and AI model deployment.",
//     link: "/dashboard/blog/blog-detail",
//   },
// ];

// const StoreDetail = () => {
//   const [isLoading, setIsLoading] = useState(true);
//   const [data, setData] = useState([]);

//   // Delay the rendering by 2 seconds
//   useEffect(() => {
//     getEnrolledCourses();
//     const timer = setTimeout(() => {
//       setIsLoading(false);
//     }, 5000);
//     return () => clearTimeout(timer);
//   }, []);

//   const getEnrolledCourses = async () => {
//     const userId = localStorage.getItem("userId");
//     console.log(userId);

//     try {
//       const response = await axios.post(webServiceUrl.enrolled_courses, {
//         userId: userId,
//       });
//       // console.log(response.data.enrolledCourses, "enrolled aaya ");
//       setData(response.data.enrolledCourses);
//     } catch (error) {
//       console.log(error, "ERROR AAGYA ");
//     }
//   };

//   return (
//     <>
//       <ProfileHeader img={profilebg7} />
//       <div id="content-page" className="content-inner store-details">
//         <Container>
//           <Row>
//             <div
//               className="header-title"
//               style={{ textAlign: "left", width: "100%" }}
//             >
//               <h1 style={{ textAlign: "center", width: "100%" }}>
//                 Enrolled Courses
//               </h1>
//             </div>
//             <Col lg="12">
//               <Row>
//                 {isLoading
//                   ? // Show Skeleton loaders while loading
//                     Array.from({ length: 6 }).map((_, index) => (
//                       <Col sm="6" md="6" lg="4" key={index} className="mt-4">
//                         <Skeleton height={250} className="rounded-3" />
//                         <Skeleton height={20} width="80%" className="mt-2" />
//                         <Skeleton height={15} width="90%" />
//                         <Skeleton height={15} width="70%" />
//                       </Col>
//                     ))
//                   : // Show actual courses after 2s
//                     data.map((course) => (
//                       <Col
//                         sm="6"
//                         md="6"
//                         lg="4"
//                         key={course?.courseId}
//                         className="mt-4"
//                       >
//                         <CourseCard course={course} />
//                       </Col>
//                     ))}
//               </Row>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </>
//   );
// };

// // Course card component
// const CourseCard = ({ course }) => {
//   const [loading, setLoading] = useState(true);

//   return (
//     <Link to="/dashboard/blog/blog-detail" className="text-decoration-none">
//       <div
//         className="card-block card-stretch card-height product border rounded p-3"
//         style={{
//           boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
//           backgroundColor: "white",
//         }}
//       >
// <div className="image-block position-relative">
//   {loading && <Skeleton height={200} className="rounded-3" />}
//   <img
//     src={course?.courseImg}
//     className="img-fluid w-100 rounded-3"
//     alt="product-img"
//     style={{ display: loading ? "none" : "block" }}
//     onLoad={() => setLoading(false)}
//   />
// </div>

//         <div className="product-description my-4">
//           <h4 className="fw-bold">{course?.courseTitle}</h4>
//           <p className="mb-0">{course?.courseVenue}</p>
//         </div>

//         <div>
//           <ul className="list-inline m-0 p-0 d-flex align-items-center justify-content-center gap-4">
//             <li>
//               <button
//                 type="button"
//                 className="btn btn-primary px-4 button-card"
//               >
//                 View Details
//               </button>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </Link>
//   );
// };

// export default StoreDetail;

// ******************************************************************
// import React from "react";
// import { Link } from "react-router-dom";
// import { Container, Row, Col } from "react-bootstrap";
// import Card from "../../../components/Card";

// // Import images
// import store1 from "../../../assets/images/page-img/robotics.png";
// import store6 from "../../../assets/images/page-img/ai.png";
// import store2 from "../../../assets/images/page-img/py.png";
// import store3 from "../../../assets/images/page-img/node.png";
// import store4 from "../../../assets/images/page-img/java.png";
// import store5 from "../../../assets/images/page-img/ml.png";

// import profilebg7 from "../../../assets/images/page-img/profile-bg7.png";

// // Import profile header component
// import ProfileHeader from "../../../components/profile-header";

// const courses = [
//   {
//     id: 1,
//     title: "Robotics Program",
//     img: store1,
//     description:
//       "Build and program robots using modern tools and hands-on projects.",
//     link: "/dashboard/blog/blog-detail",
//   },
//   {
//     id: 2,
//     title: "Python AI Program",
//     img: store2,
//     description:
//       "Learn Python for AI, covering ML, deep learning, and automation.",
//     link: "/dashboard/blog/blog-detail",
//   },
//   {
//     id: 3,
//     title: "AI Program",
//     img: store6,
//     description:
//       "Master AI concepts like neural networks, NLP, and problem-solving.",
//     link: "/dashboard/blog/blog-detail",
//   },
//   {
//     id: 4,
//     title: "MERN Stack Program",
//     img: store3,
//     description:
//       "Learn MongoDB, Express, React, and Node.js to build web apps.",
//     link: "/dashboard/blog/blog-detail",
//   },
//   {
//     id: 5,
//     title: "Java Development Program",
//     img: store4,
//     description:
//       "Master Java, OOP, Spring Boot, and enterprise app development.",
//     link: "/dashboard/blog/blog-detail",
//   },
//   {
//     id: 6,
//     title: "Machine Learning Program",
//     img: store5,
//     description:
//       "Explore ML algorithms, data science, and AI model deployment.",
//     link: "/dashboard/blog/blog-detail",
//   },
// ];

// const StoreDetail = () => {
//   return (
//     <>
//       {/* title= {"Enrolled Courses"} */}
//       <ProfileHeader img={profilebg7} />
//       <div id="content-page " className="content-inner store-details">
//         <Container>
//           <Row>
//             <div
//               className="header-title"
//               style={{ textAlign: "left", width: "100%" }}
//             >
//               <h1 style={{ textAlign: "center", width: "100%" }}>
//                 Enrolled Courses
//               </h1>
//             </div>
//             <Col lg="12">
//               <Row>
//                 {courses.map((course) => (
//                   <Col sm="6" md="6" lg="4" key={course?.id} className="mt-4">
//                     <Link to={course?.link} className="text-decoration-none">
//                       <div
//                         className="card-block card-stretch card-height product border rounded p-3"
//                         style={{ boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px" }}
//                       >
//                         <div className="image-block position-relative">
//                           <img
//                             src={course?.img}
//                             className="img-fluid w-100 rounded-3"
//                             alt="product-img"
//                           />
//                         </div>
//                         <div className="product-description my-4">
//                           <h4 className="fw-bold">{course?.title}</h4>
//                           <p className="mb-0">{course?.description}</p>
//                         </div>
//                         <div>
//                           <ul className="list-inline m-0 p-0 d-flex align-items-center justify-content-center gap-4">
//                             <li>
//                               <button
//                                 type="button"
//                                 className="btn btn-primary px-4 button-card"
//                               >
//                                 View Detials
//                               </button>
//                             </li>
//                           </ul>
//                         </div>
//                       </div>
//                     </Link>
//                   </Col>
//                 ))}
//               </Row>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </>
//   );
// };

// export default StoreDetail;
